module.exports = __webpack_public_path__ + "static/media/logo.47ca6e4a.svg";